import React from 'react'

interface PageLoaderProps {
    className?: string;
    minHeight?: string;
}

const PageLoader: React.FC<PageLoaderProps> = ({
    className = "",
    minHeight = "min-h-[calc(100vh-160px)]",
}) => {
    return (
        <div className={`flex flex-col items-center justify-center ${minHeight} w-full p-8 transition-all duration-300 ${className}`}>
            {/* Spinning gradient ring container */}
            <div className="relative flex items-center justify-center">
                {/* Outer glowing aura */}
                <div className="absolute w-24 h-24 rounded-full bg-cyan-500/10 blur-xl animate-pulse" />

                {/* Loader Rings */}
                <div className="w-16 h-16 rounded-full border-4 border-slate-100 relative">
                    <div className="absolute -inset-1 rounded-full border-4 border-t-cyan-500 border-r-transparent border-b-transparent border-l-transparent animate-spin" />
                    <div className="absolute -inset-1 rounded-full border-4 border-t-transparent border-r-transparent border-b-indigo-500 border-l-transparent animate-[spin_1.5s_linear_infinite_reverse]" />
                </div>

                {/* Center dot */}
                <div className="absolute w-3 h-3 rounded-full bg-cyan-600 animate-ping" />
            </div>

            {/* Typography */}
            <div className="mt-8 text-center space-y-2">
                <h3 className="text-base font-semibold text-slate-800 tracking-wide flex items-center justify-center gap-1">
                    Loading Content
                    <span className="inline-flex gap-0.5 ml-1">
                        <span className="w-1.5 h-1.5 rounded-full bg-cyan-500 animate-[bounce_1s_infinite_100ms]" />
                        <span className="w-1.5 h-1.5 rounded-full bg-indigo-500 animate-[bounce_1s_infinite_300ms]" />
                        <span className="w-1.5 h-1.5 rounded-full bg-violet-500 animate-[bounce_1s_infinite_500ms]" />
                    </span>
                </h3>
                <p className="text-xs text-slate-500 max-w-xs font-medium">
                    Please wait while we prepare the view for you.
                </p>
            </div>
        </div>
    )
}

export default PageLoader